import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.sofa": ["Sofa"] }, "en": { "icon.title.sofa": ["Sofa"] }, "fi": { "icon.title.sofa": ["Sohva"] }, "da": { "icon.title.sofa": ["Sofa"] }, "sv": { "icon.title.sofa": ["Soffa"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconSofa42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `Sofa`, id: "icon.title.sofa", comment: "Title for sofa icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M33.567 10.5a1.9 1.9 0 0 0-1.367.585 2.04 2.04 0 0 0-.567 1.415v2c0 .265-.101.52-.283.707a.95.95 0 0 1-.683.293H11.333a.95.95 0 0 1-.683-.293 1.02 1.02 0 0 1-.283-.707v-2c0-.53-.204-1.04-.567-1.415a1.9 1.9 0 0 0-1.367-.585c-.512 0-1.004.21-1.367.585A2.04 2.04 0 0 0 6.5 12.5v4c0 1.06.407 2.078 1.133 2.828a3.8 3.8 0 0 0 2.734 1.172h21.266a3.8 3.8 0 0 0 2.735-1.172A4.07 4.07 0 0 0 35.5 16.5v-4c0-.53-.204-1.04-.566-1.415a1.9 1.9 0 0 0-1.367-.585m-23.2 10v3m21.266-3v3m-23.2-13c0-1.591.611-3.117 1.699-4.243A5.7 5.7 0 0 1 14.233 4.5h13.534a5.7 5.7 0 0 1 4.1 1.757 6.1 6.1 0 0 1 1.7 4.243M21 15.5v-11"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-sofa-42")) {
  customElements.define("fp-icon-sofa-42", IconSofa42);
}
export {
  IconSofa42
};
